import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonComponent } from 'src/app/shared/components/common-component';
import { AtencionService } from 'src/core/atencion/atencion.service';
import { ConsultaService } from 'src/core/consulta/consulta.service';
import { CierreVeterinariaDTO, Consulta } from 'src/core/consulta/consulta.types';
import { OkcancelDialogComponent } from 'src/app/shared/components/okcancel-dialog/okcancel-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/core/user/user.service';
import { User } from 'src/core/user/user.types';
import { NotificationService } from 'src/app/notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-inicio-admin',
  templateUrl: './inicio-admin.component.html',
  styleUrls: ['./inicio-admin.component.css']
})
export class InicioAdminComponent extends CommonComponent implements OnInit {
  consultas: Consulta[] = [];
  cierreoApertura: CierreVeterinariaDTO;
  anuncioBool: Boolean;
  userSession: User;
  estado: string;
  constructor(
    public _dialog: MatDialog,

    private _consultaService: ConsultaService,
    private _userService: UserService,
    private _atencionService: AtencionService,
    private notificationServicePush: NotificationService,
    _snackBar: MatSnackBar
  ) {
    super(_snackBar);
  }

  ngOnInit(): void {
    this.getConsultas();
    this.getUserSession();
  }

  test() {
    this.estado = this.notificationServicePush.handleButtonClick("Notificación");
  }
  getUserSession() {

    this._userService.user_session$.subscribe({
      next: (user: User) => {
        this.userSession = user;
        this.tieneAnuncio();
      }
    });
  }
  tieneAnuncio() {
    if (!this.userSession?.id) {
      console.warn('No hay ID de usuario para verificar anuncio');
      return;
    }

    this._consultaService.tieneAnuncio(this.userSession.id).subscribe({
      next: (data: boolean) => {
        // Verificar si la respuesta es un error
        if (data !== null && typeof data === 'object' && (data as any).error) {
          console.error('Error en respuesta de anuncio:', (data as any).error);
          this.anuncioBool = false; // Valor por defecto
        } else {
          this.anuncioBool = data;
        }
      },
      error: (error: any) => {
        console.log('error : ', error);
        this.anuncioBool = false; // Valor por defecto en caso de error
        this.openSnackBar('Error al verificar estado de veterinaria');
      }
    });
  }

  getConsultas() {

    this._consultaService._consultasUsuarioVet$.subscribe({
      next: (consultas: Consulta[]) => {
        this.consultas = [];
        consultas.forEach((consulta) => {
          if (consulta.consultaEstadoCita === 2) {
            //consulta.consultaNombreAtencion = this._atencionService.getAtencionByIdInList(consulta.consultaIdAtencion).nombre;
            this.consultas.push(consulta);
          }
        });
      },
      error: (error: any) => {
        console.log('error : ', error);
        this.openSnackBar(error.toString());
      }
    });
  }
  confirmarCierre() {
    const message = `¿ESTA SEGURO QUE QUIERES HACER CIERRE DEL DÍA? \n EL ANUNCIO DE CIERRE POR ESTE DÍA SE ACTIVARA`;
    const dialogRef = this._dialog.open(OkcancelDialogComponent, {
      panelClass: ['rounded-lg'],
      data: { message: message }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.modificarAnuncio();
      }
    });
  }
  confirmarApertura() {
    const message = `¿ESTA SEGURO QUE QUIERES HACER APERTURA DEL DÍA? \n EL ANUNCIO DE CIERRE POR ESTE DÍA  SE DESACTIVARA `;
    const dialogRef = this._dialog.open(OkcancelDialogComponent, {
      panelClass: ['rounded-lg'],
      data: { message: message }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.modificarAnuncio();
      }
    });
  }

  modificarAnuncio() {
    this.cierreoApertura = { idVeterinaria: this.userSession.id };
    this._consultaService.modificarAnuncio(this.cierreoApertura, this.anuncioBool).subscribe({
      next: (data: boolean) => {
        // En lugar de recargar toda la página, actualizar solo el estado
        this.anuncioBool = !this.anuncioBool;
        
        // Mostrar mensaje de confirmación
        const mensaje = this.anuncioBool ? 
          'Veterinaria cerrada temporalmente' : 
          'Veterinaria abierta para citas';
        this.openSnackBar(mensaje, 3, 'success');
        
        // Refrescar las consultas para reflejar cambios
        this.getConsultas();
      },
      error: (error: any) => {
        console.log('error : ', error);
        this.openSnackBar(error.toString());
      }
    });
  }
}
